function parseNumber(num) {
    return num < 10 ? "0" + num : num;
}


export let  dateFormat = (date, formatStr)=> {
    let dateObj = {},
        rStr = /\{([^}]+)\}/,
        mons = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'];
     
    dateObj["Y"] = date.getFullYear();
    dateObj["M"] = date.getMonth() + 1;
    dateObj["MM"] = parseNumber(dateObj["M"]);
    dateObj["Mon"] = mons[dateObj['M'] - 1];
    dateObj["D"] = date.getDate();
    dateObj["DD"] = parseNumber(dateObj["D"]);
    dateObj["h"] = date.getHours();
    dateObj["hh"] = parseNumber(dateObj["h"]);
    dateObj["t"] = dateObj["h"] > 12 ? dateObj["h"] - 12 : dateObj["h"];
    dateObj["tt"] = parseNumber(dateObj["t"]);
    dateObj["A"] = dateObj["h"] > 12 ? '下午' : '上午';
    dateObj["i"] = date.getMinutes();
    dateObj["ii"] = parseNumber(dateObj["i"]);
    dateObj["s"] = date.getSeconds();
    dateObj["ss"] = parseNumber(dateObj["s"]);
 
    while(rStr.test(formatStr)) {
        formatStr = formatStr.replace(rStr, dateObj[RegExp.$1]);
    }
    return formatStr;
}



